import React from 'react'
import { ContractsModel, ContractsOmission } from '../../../../types/contracts/contractsModel'
import CardStep from '../CardStep'
import { FormattedMessage } from 'react-intl'
import ContractDetails from '../../../../modules/dashboard/dashboard_contracts/ContractDetails'
import classNames from 'classnames'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import styles from '../../../../styles'
import { ClassValue } from 'classnames/types'
import { useMediaQuery } from 'react-responsive'
import { contractsPhaseEnum, propertyType } from '../../../../enums/contractsEnum'
import SvgApartment from '../../../../icons/Apartment'
import SvgGarage from '../../../../icons/Garage'
import Loader from '../../../loader/Loader'
import Button from '../../../button/Button'

const useStyle = makeStyles(
	(theme) => (
		{
			...styles(theme),
			cardContainerStyle: {
				width: '100%',
				margin: 0
			},
			buttonStyle: {
				marginLeft: -8
			}
		}
	)
)

interface AcceptingProps {
	contractsMapped: Omit<ContractsModel, ContractsOmission>[],
	updatePropertyConcerned: (contract: any, interlocutor?: string) => void,
	multiSelect?: boolean,
	hasButton?: boolean,
	defaultSelection?: Omit<ContractsModel, ContractsOmission>[]
}

type PropertyConcernedProps = AcceptingProps

const PropertyConcerned: React.FC<PropertyConcernedProps> = (
	{
		contractsMapped,
		updatePropertyConcerned,
		multiSelect = false,
		hasButton = false,
		defaultSelection
	}
) => {
	const classes = useStyle()
	const theme = useTheme()
	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1025px)'
		}
	)
	const [selection, setSelection] = React.useState<Omit<ContractsModel, ContractsOmission>[]>(defaultSelection || [])

	const getAvailableParkings = (contrat: Omit<ContractsModel, ContractsOmission>) => {
		const parking: Omit<ContractsModel, ContractsOmission>[] = []
		if (contrat.type === propertyType.apartment) {
			if (contractsMapped.filter((contrat) => contrat.type === propertyType.apartment).length === 1) {
				contractsMapped.filter((contrat) => contrat.type === propertyType.garage && contrat.phase === contractsPhaseEnum.exploitation).forEach((contrat) => parking.push(contrat))
			}
		}

		return parking
	}

	const cardContainerClass: ClassValue = classNames(
		'row',
		{
			[classes.cardContainerStyle]: !isLargeScreen
		}
	)

	const buttonClass: ClassValue = classNames(
		'col-xs-12 col-md-4',
		{ [classes.buttonStyle]: isLargeScreen }
	)

	const getBlocDescription = (contract: Omit<ContractsModel, ContractsOmission>) => {
		const type: string = `dashboard.contracts.type.${contract.type}`

		const cardTypeClass = classNames(
			classes.text7
		)

		return (
			<>
				<h2 className={cardTypeClass}>
					<FormattedMessage
						id={type}
						defaultMessage={contract.type}
						description="Contract type"
					/>
				</h2>

				<ContractDetails
					contract={contract}
					text="text3"
				/>
			</>
		)
	}

	const getImg = (type: string, isSelected: boolean) => {
		const imgProperty = {
			color: isSelected ? 'white' : theme.palette.blue.main,
			width: 50,
			height: 50
		}
		if (type === propertyType.apartment) {
			return <SvgApartment {...imgProperty} />
		} else {
			return <SvgGarage {...imgProperty} />
		}
	}

	const handleSelection = (contract: Omit<ContractsModel, ContractsOmission>) => {
		// Si multiselect, gestion locale pour le rendu
		if (multiSelect) {
			const indexFound = selection.map((contract) => contract.lease).indexOf(contract.lease)
			if (indexFound !== -1) {
				const newProperties = [...selection]
				newProperties.splice(indexFound, 1)
				setSelection([...newProperties])
			} else {
				const parkings = getAvailableParkings(contract)
				if (parkings.length > 0) {
					const parkingIndexs = parkings.map((parking) => selection.map((contract) => contract.lease).indexOf(parking.lease))
					parkingIndexs.forEach((parkingIndex) => selection.splice(parkingIndex, 1))
					setSelection([...selection, contract, ...parkings])
				} else {
					setSelection([...selection, contract])
				}
			}
		} else {
			// On délègue au stepper
			updatePropertyConcerned(contract, contract.interlocutor)
		}
	}

	return (
		<>
			{
				contractsMapped.length > 0 &&
				<div className={cardContainerClass}>
					<div className="col-xs-12 row">
						{
							contractsMapped.filter((contractMapped) => contractMapped.phase === contractsPhaseEnum.exploitation).map(
								(contract) => {
									const isSelected = selection.map(contract => contract.lease).indexOf(contract.lease) !== -1
									return (
										<CardStep
											key={contract.lease}
											blocDescription={getBlocDescription(contract)}
											img={getImg(contract.type, isSelected)}
											setSelected={() => handleSelection(contract)}
											multiSelect={multiSelect}
											isSelected={isSelected}
											hasButton={hasButton}
										/>
									)
								}
							)
						}
					</div>
					{multiSelect && <div className={buttonClass}>
						<Button
							background="backgroundAccessibility"
							color="colorWhite"
							textStyle="text8"
							onClick={() => updatePropertyConcerned(selection)}
							disabled={selection.length === 0}
						>
							<FormattedMessage
								id="global.btn.next"
								defaultMessage="Suivant"
								description="Next"
							/>
						</Button>
					</div>}
				</div>
			}
			{
				contractsMapped.length === 0 &&
				<Loader />
			}
		</>
	)
}

export default PropertyConcerned
